var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "login"
  }, [_c('div', {
    staticClass: "background",
    style: {
      'background-color': _vm.themeConfig.bg_color
    }
  }), _c('div', {
    staticClass: "container-scroller"
  }, [_c('div', {
    staticClass: "container-fluid page-body-wrapper full-page-wrapper"
  }, [_c('div', {
    staticClass: "\n            content-wrapper\n            d-flex\n            align-items-center\n            justify-content-center\n            auth\n            theme-one\n          "
  }, [_c('div', {
    staticClass: "row w-100"
  }, [_c('div', {
    staticClass: "col-lg-4 mx-auto"
  }, [_c('div', {
    staticClass: "auto-form-wrapper"
  }, [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoading
    }
  }, [_vm.themeConfig.logo_url ? _c('div', {
    staticClass: "text-center mb-3"
  }, [_c('img', {
    staticClass: "logo-img",
    attrs: {
      "src": _vm.themeConfig.logo_url
    }
  })]) : _vm._e(), _c('div', {
    staticClass: "text-center mb-3"
  }, [_c('h4', [_vm._v(_vm._s(_vm.organizationName) + " 管理後台")])]), _c('form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
      }
    }
  }, [_vm.validationErrors ? _c('validation-error-alert', {
    attrs: {
      "errors": _vm.validationErrors
    }
  }) : _vm._e(), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.authFieldName))]), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.auth_field,
      expression: "form.auth_field"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": '請輸入' + _vm.authFieldName
    },
    domProps: {
      "value": _vm.form.auth_field
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "auth_field", $event.target.value);
      }
    }
  }), _c('div', {
    staticClass: "input-group-append"
  }, [_c('span', {
    staticClass: "input-group-text"
  })])])]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("密碼")]), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.password,
      expression: "form.password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": "請輸入密碼"
    },
    domProps: {
      "value": _vm.form.password
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "password", $event.target.value);
      }
    }
  }), _c('div', {
    staticClass: "input-group-append"
  }, [_c('span', {
    staticClass: "input-group-text"
  })])])]), _vm.themeConfig.enable_captcha ? _c('vue-turnstile', {
    staticClass: "mb-2",
    attrs: {
      "site-key": _vm.siteKey,
      "theme": "light"
    },
    on: {
      "verified": function verified($event) {
        _vm.token = $event;
      }
    }
  }) : _vm._e(), _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-primary submit-btn btn-block",
    attrs: {
      "disabled": _vm.isSubmitting
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(" 登入 ")])])], 1)])], 1), _vm.footerText ? _c('p', {
    staticClass: "footer-text text-center"
  }, [_vm._v(" " + _vm._s(_vm.footerText) + " ")]) : _vm._e()])])])])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }